import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import AsyncSelect from "react-select";
import * as APIS from "../../../service/apis/products.apis";
import LeftArray from "assets/images/leftArrow.png";
import RightArray from "assets/images/rightArrow.png";
import { history } from "redux/store/store";

function slideFun(arr = []) {
  return arr.map((x, index) => {
    return (
      <span
        key={index}
        onClick={() => history.push(`/product?id=${x.node.id}`)}
        className="cursor-pointer"
      >
        <img
          src={x.node.images.nodes[0]?.url}
          className="mx-auto"
          alt={x.node.title}
          style={{ width: "76px" }}
        />
        <p className="text-center mb-0">{x.node.title}</p>
      </span>
    );
  });
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        backgroundImage: `url(${RightArray})`,
        backgroundRepeat: "no-repeat",
        display: "none",
        content: "none",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        backgroundImage: `url(${LeftArray})`,
        backgroundRepeat: "no-repeat",
        display: "none",
        content: "none",
      }}
      onClick={onClick}
    />
  );
}
let settings = {
  dots: false,
  infinite: true,
  slidesToShow: 9,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
};


function CustomTabs(props) {
  const [key, setKey] = useState("");
  const [products, setProducts] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showInput, setshowInput] = useState(false);
  const [useTrue, setuseTrue] = useState(false);
  const [productName, setProductName] = useState("");
  const [productValue, setProductValue] = useState("");

  const param = new URLSearchParams(window.location.search);
  const id = param.get("id");

  const location = useLocation();
  const currentPath = location.pathname;
  const search = location.search;

  const dropdownMenu = useRef("");
  const secondaryheader = useRef("");

  async function temp() {
    let newResult = await APIS.GetCategories();
    let result = newResult.filter(
      (item) => item.id === "gid://shopify/Collection/291967631526"
    );

    let a = [
      { title: "Contact Us", to: "/", id: 2 },
      { title: "About VB Dace", to: "/", id: 3 },
      { title: "Shipping & Returns", to: "/", id: 4 },
    ];
    let d = result.concat(a);
    setCategories(d);

    let prducts = await APIS.ProductSearch({ search: "*" });
    if (prducts.length)
      prducts = prducts.map((x) => (
        {
          label: x.node.title,
          value: x.node.id,
          handle: x.node.handle
        }
      ));

    setProductsList(prducts);
  }

  useEffect(() => {
    temp();
  }, []);

  let productData = async (id) => {
    if (id === "search") {
      setKey(id);
      setshowInput(!showInput);
      return;
    } else if (id == 1) {
      history.push("/#product");
    } else if (id == 2) {
      history.push(`/static/${"contact"}`);
    } else if (id == 3) {
      history.push(`/static/${"about"}`);
    } else if (id == 4) {
      history.push(`/static/${"shipping"}`);
    }

    let products = await APIS.GetProductsByCategory({ categoryId: id });
    setProducts(products);
    setKey(id);
  };

  let getProducts = (data) => {
    try {
      if (typeof data == "object") {
        setProductValue(data);
        history.push(`/product/${data.handle}`);
      }
      APIS.ProductSearch({ search: `*${data}*` }).then((prducts) => {
        if (prducts.length > 0) {
          prducts = prducts.map((x) => ({
            label: x.node.title,
            value: x.node.id,
            handle: `${x.node.handle}`,
          }));
          setProductsList(prducts);
          productsList.unshift({ label: "Shop All", value: "", handle: "/" });
        }
      });
    } catch (error) {
      alert(error);
    }
  };

  function openMenu() {
    dropdownMenu.current.classList.add("d-block");
  }
  function closeMenu() {
    dropdownMenu.current.classList.remove("d-block");
  }

  function searchOpen() {
    secondaryheader.current.classList.toggle("d-none");
  }


  return (
    <>
      <nav className="navbar navbar-expand-lg primary-header">
        <div className="container-fluid">
          <div className="collapse navbar-collapse row" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a
                  className={`nav-link ${currentPath === "/" ? "active" : ""}`}
                  aria-current="page"
                  href="/"
                >
                  Home
                </a>
              </li>

              <li
                className="nav-item dropdown"
                onMouseEnter={openMenu}
                onMouseLeave={closeMenu}
              >
                <a
                  className={`dropdown-toggle nav-link ${currentPath === "/category" ? "active" : ""
                    }`}
                  // href="/category?id=gid://shopify/Collection/291967631526"
                  href="/category/allproducts"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Products
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdown"
                  ref={dropdownMenu}
                >
                  <li>
                    <div
                      className="dropdown-item sub-main"
                      style={{cursor:"pointer"}}
                      onClick={() => history.push('/category/cookware')}
                    >

                      <div className="sub-category-wrapper"> 
                        Cookware

                        <ul className="sub-category" style={{borderRadius: '0'}}>
                          <li><a href="/category/triply-series">Triply Series</a></li>
                          <li><a href="/category/bronze-series">Bronze Series</a></li>
                          <li><a href="/category/cast-iron-series">Cast Iron Series</a></li>
                          <li><a href="/category/stainless-steel-series">Stainless Steel Series</a></li>
                        </ul>
                        
                      </div>
                    </div>
                  </li>

                  <li>
                    <a
                      className="dropdown-item"
                      href="/category/tableware"
                    >
                      Tableware
                    </a>
                  </li>


                  <li>
                    <a
                      className="dropdown-item"
                      href="/category/kitchen-mate"
                    >
                      Kitchen Mate
                    </a>
                  </li>
                  <li>
                    <div
                      className="dropdown-item sub-main"
                      onClick={() => history.push('/category/kitchen-tools-accessories-and-spares')}
                      style={{cursor:"pointer"}}
                    >
                      <div className="sub-category-wrapper"> 
                        Kitchen tools, Accessories and Spares
                        <ul className="sub-category" style={{borderRadius: '0'}}>
                          <li><a href="/category/kitchen-tools">Kitchen Tools</a></li>
                          <li><a href="/category/accessories">Accessories</a></li>
                          <li><a href="/category/spares">Spares</a></li>
                          </ul>
                      </div>
                    </div>
                  </li>

                </ul>
              </li>

              <li className="nav-item">
                <a
                  className={`nav-link ${location.pathname === "/static/about" ? "active" : ""}`}
                  href="/static/about"
                >
                  About VB Dace
                </a>
              </li>


              <li className="nav-item">
                <a
                  className={`nav-link ${location.pathname === "/contact-us" ? "active" : ""
                    }`}
                  href="/contact-us"
                >
                  Contact Us
                </a>
              </li>

              <li className="nav-item">
                <a
                  className={`nav-link ${location.pathname === "/our-experience-centers" ? "active" : ""
                    }`}
                  href="/our-experience-centers"
                >
                  Our Experience Centers
                </a>
              </li>


              <li className="nav-item">
                <a
                  className={`nav-link ${location.pathname === "/static/shipping" ? "active" : ""
                    }`}
                  href="/static/shipping"
                >
                  Shipping & Delivery
                </a>
              </li>
            </ul>

            <div className="d-flex sear pr-5">
              <div className="divv" onClick={searchOpen}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                  />
                </svg>

                <p>Search</p>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <nav className="d-none navbar navbar-expand-lg secondary-header" ref={secondaryheader}>
        <div className="container-fluid">
          <div
            className="collapse navbar-collapse row text-center"
            id="navbarSupportedContent"
          >
            <div className="col-lg-5" >
              <AsyncSelect
                className="searchBar"
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: '#CDA774',
                    primary: '#b68a68'
                  },
                })}
                options={productsList}
                name={"ProductName"}
                value={productValue}
                onChange={(val) => getProducts(val)}
                onInputChange={(value) => getProducts(value)}
                placeholder={`Search products.`}
              />
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export const TopTabs = CustomTabs;
